import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './somethingWentWrong.module.scss'

interface PropType {
  show?: boolean
  minHeight?: string
  wrapperClass?: string
}

function SomethingWentWrong({ show = true, minHeight, wrapperClass }: PropType) {
  const { t } = useTranslation('accountPage')
  if (!show) return null

  return (
    <div className={classNames(styles.graceful_error_message_wrapper, wrapperClass)} style={{ minHeight }}>
      <div className={styles.graceful_error_message_content}>
        {t('somethingWentWrong')}
        <br />
        {t('refreshPage')}
      </div>
    </div>
  )
}

export default SomethingWentWrong
